import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import injectIntl from 'common/injectIntl';
import WatchPropTypes from 'common/PropTypes';
import Alert from 'common/alert/Alert';
import { dateFormat } from 'lib/format';
import { dateFormatSelector } from 'common/selectors/appSelector';
import { userLocationSelector } from 'common/selectors/authenticationSelectors';

/**
 * Upcoming Alert UI component
 */
const UpcomingAlert = ({
    align,
    animation,
    className,
    content,
    displayTime,
    dateFormatStr,
    messages,
    moreText,
    onClose,
    style,
    userLocation
}) => {
    const { name, utc, source: sourceArg, subtitle } = content;
    const timeZone = userLocation && userLocation.timeZone;
    const startTime = displayTime || dateFormat.getDateTimeString(utc, dateFormatStr, timeZone);
    let source = sourceArg;
    if (!source && subtitle.indexOf(' • ') > -1) {
        const tmpArr = subtitle.split(' • ');
        source = tmpArr.shift();
    }
    const message = (
        <FormattedMessage
            {...messages['schedule.module.alert.upcoming']}
            tagName="p"
            values={{
                name,
                startTime: <span>{startTime}</span>,
                source,
                moreText
            }}
        />
    );
    return (
        <Alert
            align={align}
            animation={animation}
            className={className}
            message={message}
            style={style}
            onClose={onClose}
        />
    );
};

UpcomingAlert.propTypes = {
    ...Alert.propTypes,
    content: WatchPropTypes.content,
    displayTime: PropTypes.string,
    dateFormatStr: PropTypes.string,
    moreText: PropTypes.string,
    userLocation: PropTypes.object
};

UpcomingAlert.defaultProps = {
    content: {},
    moreText: ''
};

const mapStateToProps = (state) => ({
    dateFormatStr: dateFormatSelector(state),
    userLocation: userLocationSelector(state)
});

export default connect(mapStateToProps)(injectIntl(UpcomingAlert));



// WEBPACK FOOTER //
// ./app/webapp/alert/UpcomingAlert.js